import { render, staticRenderFns } from "./DDSCard.vue?vue&type=template&id=b35b4bf2&scoped=true"
import script from "./DDSCard.vue?vue&type=script&lang=js"
export * from "./DDSCard.vue?vue&type=script&lang=js"
import style0 from "./DDSCard.vue?vue&type=style&index=0&id=b35b4bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35b4bf2",
  null
  
)

export default component.exports